module.exports = __webpack_public_path__ + "static/media/yadnyadeep_khadke.41731a8d.jpg";